export const validCreditCardNumber = (cardNumber) => {
  const cleanNumber = cardNumber.replace(/\D/g, '');
  
  // Check if card number is empty or too short
  if (!cleanNumber || cleanNumber.length < 13) {
    return false;
  }
  
  // Accept cards with 13-19 digits (covers Visa, Mastercard, American Express, etc.)
  if (cleanNumber.length < 13 || cleanNumber.length > 19) {
    return false;
  }
  
  // Luhn algorithm for card number validation
  let sum = 0;
  let isEven = false;
  
  // Loop through values starting from the right
  for (let i = cleanNumber.length - 1; i >= 0; i--) {
    let digit = parseInt(cleanNumber.charAt(i), 10);
    
    if (isEven) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    
    sum += digit;
    isEven = !isEven;
  }
  
  return (sum % 10) === 0;
};